import AXIOS from '@/utils/$axios';

export const createFolder = payload =>
    AXIOS.post('/space/resource-folder/create', payload);

export const getFolderList = payload =>
    AXIOS.post('/space/resource-folder/get-list', payload);

export const deleteFolder = payload =>
    AXIOS.post('/space/resource-folder/delete', payload);

export const editFolder = payload =>
    AXIOS.post('/space/resource-folder/edit', payload);

export const createSuspended = payload =>
    AXIOS.post('/space/resource/suspended/create', payload);

export const editSuspended = payload =>
    AXIOS.post('/space/resource/suspended/edit', payload);

export const getSuspendedList = payload =>
    AXIOS.post('/space/resource/suspended/get-list', payload);

export const deleteResource = payload =>
    AXIOS.post('/space/resource/model/change', payload);

export const moveResource = payload =>
    AXIOS.post('/space/resource/suspended/move-batch', payload);

export const storeBatchResource = payload =>
    AXIOS.post('/space/resource/suspended/store-batch', payload);

export const moveEnterpriseLibraryResource = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-library-move', payload);

export const editEnterpriseLibraryResource = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-library-edit', payload);

export const createEnterpriseFolder = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-folder-create', payload);

export const editEnterpriseFolder = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-folder-edit', payload);

export const deleteEnterpriseFolder = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-folder-delete', payload);

export const bindEnterpriseLibraryResource = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-library-bind', payload);

export const unbindEnterpriseLibraryResource = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-library-unbind', payload);

export const sortEnterpriseFolders = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-folder-sort', payload);

export const editEnterpriseFolderImgName = payload =>
    AXIOS.post('/space/hdd/resource/enterprise-folder-image', payload);

export const getEnterpriseFolders = params =>
    AXIOS.post('/lws/common/hdd-enterprise-folder', params);

export const getEnterpriseModels = params =>
    AXIOS.post('/lws/common/hdd-enterprise-models', params);
